import { observable } from '@legendapp/state';
import Decimal from 'decimal.js';
import type { BaseBonusResponseDto } from '../api';
import { configurationState$ } from './configuration.state';

type FreeBetState = {
  bonusAmount: number;
  bonusCount: number;
  bonusTotalCount: number;
  isActive: boolean;
  isSummaryOpened: boolean;
  totalWin: number;

  initialize: (bonus: BaseBonusResponseDto) => void;
  update: (bonus?: BaseBonusResponseDto, showSummary?: boolean) => void;
};

export const freeBetState$ = observable<FreeBetState>({
  bonusAmount: 0,
  bonusCount: 0,
  bonusTotalCount: 0,
  isActive: false,
  isSummaryOpened: false,
  totalWin: 0,

  initialize: (bonus) => {
    const coefficient = configurationState$.coeficient.peek();

    freeBetState$.assign({
      bonusAmount: new Decimal(bonus.bonusAmount).div(coefficient).toNumber(),
      bonusCount: bonus.bonusCount,
      bonusTotalCount: bonus.bonusTotalCount,
      isActive: bonus.isActive === true && bonus.bonusCount > 0,
      isSummaryOpened: false,
      totalWin: new Decimal(bonus.totalWin).div(coefficient).toNumber(),
    });
  },
  update: (bonus, showSummary = false) => {
    if (bonus) {
      const coefficient = configurationState$.coeficient.peek();

      freeBetState$.assign({
        bonusAmount: new Decimal(bonus.bonusAmount).div(coefficient).toNumber(),
        bonusCount: bonus.bonusCount,
        bonusTotalCount: bonus.bonusTotalCount,
        isActive: bonus.isActive === true && bonus.bonusCount > 0,
        isSummaryOpened:
          showSummary === true &&
          bonus.isActive === true &&
          bonus.bonusCount === 0,
        totalWin: new Decimal(bonus.totalWin).div(coefficient).toNumber(),
      });
    } else {
      freeBetState$.assign({
        bonusAmount: 0,
        bonusCount: 0,
        bonusTotalCount: 0,
        isActive: false,
        isSummaryOpened: false,
        totalWin: 0,
      });
    }
  },
});
